import { useEffect, useState } from 'react';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import {
  getSellClientHoldingFunds,
  getSellOrderClientHoldingOfSelectedFund,
  sellOrderFunds,
} from '../../store/actions/fund-action';
import { useNavigate } from 'react-router';
import { languages } from '../../config/config';
import { setSellOrderClientHoldingOfSelectedFund } from '../../store/slices/fund-slice';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { fundsContent, language } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);
  const {
    fund_loading,
    fund_document_loading,
    sellClientHoldingFunds,
    sellOrderClientHoldingOfSelectedFund,
  } = useSelector((state) => state.fund);

  const [reviewModal, setReviewModal] = useState(false);
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    dispatch(getSellClientHoldingFunds(language === languages.eng ? 3 : 4));
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_sell_order?.data?.attributes,
      key,
      isArabic
    );
  };

  const toogleReviewModal = () => setReviewModal(!reviewModal);

  const handleReviewOrder = (values, functions) => {
    setOrderData({ ...values, resetForm: functions?.resetForm });
    toogleReviewModal();
  };

  const onVerify = () => {
    const api_data = new FormData();
    api_data.append('FundId', orderData?.fundName?.fundId);
    api_data.append('UnitsRequested', orderData?.amount);
    api_data.append('PriceRequested', 0);
    api_data.append('investorTypeId', user?.investorTypeId);

    dispatch(
      sellOrderFunds(api_data, (val) => {
        toogleReviewModal();
        dispatch(setSellOrderClientHoldingOfSelectedFund(null));
        navigate('/funds/internal-unit-exchange');
      })
    );
  };

  return {
    sellClientHoldingFunds,
    orderData,
    TextWeight,
    fund_loading,
    getContentKey,
    onVerify,
    reviewModal,
    setReviewModal,
    toogleReviewModal,
    handleReviewOrder,
    fund_document_loading,
    navigate,
    dispatch,
    getSellOrderClientHoldingOfSelectedFund,
    sellOrderClientHoldingOfSelectedFund,
    setSellOrderClientHoldingOfSelectedFund,
    isArabic,
    direction,
    user,
  };
};
